export const PROMO_PARTICIPATE_EUROCUP = 'one-hub-vw-1.0/promotions/participate-euro2025';
